export const success = "#22c322";
export const failed = "#eb4747";
export const info = "#3d99f5";
const x = document.getElementById("errormsg");

type PositionType = "bottom-center" | "bottom-right" | "bottom-left" | "top-left" | "top-right" | "top-center" | "left-center" | "right-center"

export function showMessage(msg: string, color?: string, duration = 2000, toastStyle?: {
  position: PositionType
}) {
  if (!x) return;
  const positionBase = "1rem";
  x.innerHTML = msg;
  x.style.backgroundColor = color || success;
  x.style.color = "white";
  x.style.fontFamily = "Inter";
  x.style.fontWeight = "500";
  x.style.maxWidth = "600px";
  x.className = "show";
  if(!toastStyle) {
    x.style.left = "50%";
    x.style.bottom = positionBase;
  }
  if(toastStyle?.position === "bottom-center") {
    x.style.bottom = positionBase,
    x.style.left = "50%";
    x.style.transform = "translateX(-50%)"
  }
  if(toastStyle?.position === "bottom-right") {
    x.style.bottom = positionBase;
    x.style.right = positionBase
  }
  if(toastStyle?.position === "bottom-left") {
    x.style.bottom = positionBase;
    x.style.left = positionBase
  }
  if(toastStyle?.position === "top-left") {
    x.style.top = positionBase;
    x.style.left = positionBase
  }
  if(toastStyle?.position === "top-center") {
    x.style.top = positionBase;
    x.style.left = "50%";
    x.style.transform = "translateX(-50%)"
  }
  if(toastStyle?.position === "top-right") {
    x.style.top = positionBase;
    x.style.right = positionBase
  }
  if(toastStyle?.position === "left-center") {
    x.style.top = "50%";
    x.style.left = positionBase;
    x.style.transform = "translateY(-50%)"
  }
  if(toastStyle?.position === "right-center") {
    x.style.top = "50%";
    x.style.right = positionBase;
  }
  setTimeout(function() {
    x.className = x.className.replace("show", "");
  }, duration);
}
x && x.addEventListener("click",()=>x.className = "")
export function showHttpError(err: any) {
  let message = err.message || err;
  if (err && err.response) {
    if (err.response.data) {
      message = err.response.data.message;
    } else {
      message = err.response.message;
    }
  }
  showMessage(message, failed, 3000);
}

export default showMessage;
